import React from 'react';
import CustomTitle from "@/components/custom_title";
import Layout from "@/locales/en/layout/Layout";
import {useTranslation} from "react-i18next";
import {useQuery} from "react-query";
import {getNewsId, imgUrl} from "@/api/general";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, FreeMode, Navigation, Pagination} from "swiper";
import {NewsIdWrapper} from "@/components/news/NewsPageWrapper";

function EcoTalaba(props) {
    document.title = "Eco Talaba";
    const {data} = useQuery({
        queryKey: ["todos", 554],
        queryFn: () => getNewsId(554),
    });
    console.log(data)
    const {t} = useTranslation();


    return (
        <Layout>
            <CustomTitle name={t("header.header__bottom__nav__item__menu.menu-4.item-48")}/>
            <NewsIdWrapper>
                <div className="container  mt-lg-5 mt-3">
                    <div className="content-news">
                        <div className="">
                            <h1 className="text1">{data?.data?.data?.title} </h1>

                            <img
                                className="fotoGlavni"
                                src={imgUrl + data?.data?.data?.img}
                                alt={data?.data?.data?.title}
                                title={data?.data?.data?.title}
                            />
                        </div>
                    </div>

                    <p dangerouslySetInnerHTML={{__html: data?.data?.data?.text1}}/>
                </div>
                <CustomTitle name={t("lavhalar")} my={true}/>
                <div className="container">
                    <Swiper
                        breakpoints={{
                            140: {
                                slidesPerView: 2,
                            },

                            1200: {
                                slidesPerView: 3,

                            },
                        }}
                        slidesPerView={3}
                        spaceBetween={10}
                        freeMode={true}
                        pagination={{
                            clickable: true,
                        }}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        navigation={false}
                        modules={[FreeMode, Pagination, Navigation, Autoplay]}
                        className="mySwiper"
                    >
                        {data?.data?.data?.imgs?.split(",")?.map((v, i, a) => (
                            <SwiperSlide key={i}>
                                <img
                                    className="img-foto"
                                    src={
                                        i === 0
                                            ? `${imgUrl}${v.substring(1, v.length - 1).substring(1)}`
                                            : i === a.length - 1
                                                ? `${imgUrl}${v.substring(1, v.length - 1).slice(0, -1)}`
                                                : `${imgUrl}${v.substring(1, v.length - 1)}`
                                    }
                                    alt=""
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </NewsIdWrapper>
        </Layout>
    );
}

export default EcoTalaba;